import { InjectionToken } from '@angular/core';

export enum EntityStoreKey {
  featureFlags = 'featureFlags',
}

export type FeatureFlagsMap = Record<FeatureFlag, boolean>;
export const FEATURE_FLAGS = new InjectionToken<FeatureFlagsMap>('Feature flags map');

export enum FeatureFlag {
  BetaTesters = 'beta-testers',
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  Webhooks = 'webhooks',
  NewCareers = 'new_careers',
  MicrosoftEmailVendor = 'microsoft_email_vendor',
  Billing = 'billing',
  EventDebug = 'debug_event_tracking',
  EEO = 'eeo',
  AuditLogs = 'audit_logs',
  FairEvaluations = 'fair_evaluations_enabled',
}
